export class CollectionResourceRequestParams {
    constructor(
        public start: number = null,
        public count: number = null,
        public topicId: number = null
    ) {}
}
